export default {
  momentLocale: 'ko',
  Timeline: {
    expand: '펼치기',
    fold: '접기',
  },
  Balloon: {
    close: '닫기',
    confirm: '확인',
    cancel: '취소',
  },
  Card: {
    expand: '펼치기',
    fold: '접기',
  },
  Calendar: {
    today: '오늘',
    now: '이 순간',
    ok: '확인',
    clear: '삭제',
    month: '월',
    year: '년',
    prevYear: '지난해',
    nextYear: '다음 해',
    prevMonth: '지난 달',
    nextMonth: '다음 달',
    prevDecade: '지난 12년',
    nextDecade: '12년 후',
    yearSelectAriaLabel: '년도 선택',
    monthSelectAriaLabel: '월 선택',
    format: {
      months: '1 월_2 월_3 월_4 월_5 월_6 월_7 월_8 월_9 월_10 월_11 월_12 월'.split('_'),
      shortMonths: '1 월_2 월_3 월_4 월_5 월_6 월_7 월_8 월_9 월_10 월_11 월_12 월'.split('_'),
      weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
      shortWeekdays: '일_월_화_수_목_금_토'.split('_'),
      veryShortWeekdays: '일_월_화_수_목_금_토'.split('_'),
      yearLabel: 'YYYY 년',
    },
  },
  DatePicker: {
    placeholder: '날짜를 선택해 주세요',
    datetimePlaceholder: '날짜와 시간을 선택해 주세요',
    monthPlaceholder: '월을 선택해 주세요',
    yearPlaceholder: '년을 선택하세요',
    now: '이 순간',
    selectTime: '시간 선택',
    selectDate: '날짜 선택',
    ok: '확인',
    clear: '삭제',
    startPlaceholder: '시작일',
    endPlaceholder: '종료일',
    hour: '시간',
    minute: '분',
    second: '초',
  },
  Dialog: {
    close: '닫기',
    ok: '확인',
    cancel: '취소',
  },
  Message: {
    closeAriaLabel: '닫기',
  },
  Pagination: {
    goTo: '이동하기',
    page: '페이지',
    total: '{current}페이지, 총 {total}페이지',
    labelPrev: '이전 페이지, 현재 {current} 페이지',
    labelNext: '다음 페이지, 현재 페이지 {current}',
    inputAriaLabel: '어느 페이지로 이동할까요? 페이지 번호를 입력하세요',
    selectAriaLabel: '페이지당 표시할 항목 수를 선택하세요',
    pageSize: '항목/페이지',
  },
  Input: {
    clear: '지우기',
  },
  Select: {
    selectPlaceholder: '선택해 주세요',
    autoCompletePlaceholder: '입력하십시오',
    notFoundContent: '옵션 없음',
    maxTagPlaceholder: '{selected}/{total} 개 선택됨',
  },
  Table: {
    empty: '데이터 없음',
    ok: '확인',
    reset: '재설정',
    asc: '오름차순',
    desc: '내림차순',
    expanded: '펼쳐짐',
    folded: '접어들어',
    filter: '필터링',
    selectAll: '전체 선택',
  },
  TimePicker: {
    placeholder: '시간을 선택해 주세요',
    startPlaceholder: '시작 시간',
    endPlaceholder: '종료 시간',
    clear: '지우기',
    hour: '시간',
    minute: '분',
    second: '초',
  },
  Transfer: {
    items: '개',
    item: '개',
    moveAll: '모두 이동',
    searchPlaceholder: '입력해주세요',
    moveToLeft: '선택 취소',
    moveToRight: '선택한 항목 제출',
  },
  Upload: {
    card: {
      cancel: '취소',
      addPhoto: '이미지 업로드',
      download: '다운로드',
      delete: '삭제',
    },
    drag: {
      text: '클릭하거나 파일을 점선 상자 안으로 끌어당겨 업로드하세요',
      hint: 'docx, xls, PDF, rar, zip, PNG, JPG 등의 파일 형식을 지원합니다',
    },
    upload: {
      delete: '삭제',
    },
  },
  Search: {
    buttonText: '검색',
  },
  Tag: {
    delete: '삭제',
  },
  Rating: {
    description: '평점 옵션',
  },
};
